// Polyfill for Math.round10 used in original code
if (!Math.round10) {
  Math.round10 = function(value, exp) {
    if (typeof exp === 'undefined' || +exp === 0) return Math.round(value);
    const shift = Math.pow(10, -exp);
    return Math.round(value * shift) / shift;
  };
}

export function useFormatting() {
  function toFloatForDisplay(float, digits) {
    return float.toFixed(digits).replace('.', ',');
  }

  function toMoney(val) {
    return isNaN(val) ? '?\xa0€' : toFloatForDisplay(Math.round10(val, -2), 2) + '\xa0€';
  }

  function toDecimal4(val) {
    return isNaN(val) ? '?' : Math.round10(val, -4).toString().replace('.', ',');
  }

  function shownStringToFloat(val) {
    if (typeof val === 'string') {
      return parseFloat(val.replace(',', '.')).toFixed(2);
    }
    return val;
  }

  return { toFloatForDisplay, toMoney, toDecimal4, shownStringToFloat };
}
